import { render, staticRenderFns } from "./LoaderUI.vue?vue&type=template&id=dd7ee7ea&scoped=true&"
import script from "./LoaderUI.vue?vue&type=script&lang=js&"
export * from "./LoaderUI.vue?vue&type=script&lang=js&"
import style0 from "./LoaderUI.vue?vue&type=style&index=0&id=dd7ee7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7ee7ea",
  null
  
)

export default component.exports